/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './ticket.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from 'ngx-bootstrap/popover/popover.directive';
import * as i4 from 'ngx-bootstrap/popover/popover.config';
import * as i5 from 'ngx-bootstrap/component-loader/component-loader.factory';
import * as i6 from '../../../../../../app/shared/components/tickets/ticket/ticket.component';
import * as i7 from '../../../../../../app/core/services/common-api.service';
import * as i8 from '../../../../../../app/core/services/global-app-state.service';
const styles_TicketComponent:any[] = [i0.styles];
export const RenderType_TicketComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TicketComponent,data:{}});
export function View_TicketComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵpid(0,i2.DatePipe,[i1.LOCALE_ID]),(_l()(),i1.ɵeld(1,0,(null as any),
      (null as any),11,'div',[['class','ticket-container']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['\n  '])),(_l()(),i1.ɵeld(3,0,(null as any),(null as any),1,'span',[['class',
      'queue']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(4,(null as any),['',''])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵeld(6,16777216,(null as any),(null as any),3,'a',[['class','date'],
          ['placement','bottom'],['target','_blank'],['triggers','mouseenter:mouseleave']],
          [[8,'href',4]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(7,212992,(null as any),0,i3.PopoverDirective,[i1.ElementRef,i1.Renderer2,
          i1.ViewContainerRef,i4.PopoverConfig,i5.ComponentLoaderFactory],{popover:[0,
          'popover'],popoverTitle:[1,'popoverTitle'],placement:[2,'placement'],triggers:[3,
          'triggers']},(null as any)),(_l()(),i1.ɵted(8,(null as any),['\n    ','\n  '])),
      i1.ɵppd(9,2),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(11,
          0,(null as any),(null as any),0,'i',[['class','fa fa-check-circle resolve']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i6.TicketComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onResolveClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        var _co:i6.TicketComponent = _v.component;
        const currVal_2:any = _co.ticket.description;
        const currVal_3:any = _co.ticket.subject;
        const currVal_4:any = 'bottom';
        const currVal_5:any = 'mouseenter:mouseleave';
        _ck(_v,7,0,currVal_2,currVal_3,currVal_4,currVal_5);
      },(_ck,_v) => {
        var _co:i6.TicketComponent = _v.component;
        const currVal_0:any = _co.ticket.queue;
        _ck(_v,4,0,currVal_0);
        const currVal_1:any = _co.ticket.link;
        _ck(_v,6,0,currVal_1);
        const currVal_6:any = i1.ɵunv(_v,8,0,_ck(_v,9,0,i1.ɵnov(_v,0),_co.ticket.date,
            'short'));
        _ck(_v,8,0,currVal_6);
      });
}
export function View_TicketComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-ticket',
      ([] as any[]),(null as any),(null as any),(null as any),View_TicketComponent_0,
      RenderType_TicketComponent)),i1.ɵdid(1,245760,(null as any),0,i6.TicketComponent,
      [i7.CommonApiService,i8.GlobalAppStateService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const TicketComponentNgFactory:i1.ComponentFactory<i6.TicketComponent> = i1.ɵccf('re-ticket',
    i6.TicketComponent,View_TicketComponent_Host_0,{ticket:'ticket'},{resolve:'resolve'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3RpY2tldHMvdGlja2V0L3RpY2tldC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS90cmF2aXMvYnVpbGQvaW5zcGlyZWhlcC9yZWNvcmQtZWRpdG9yL3NyYy9hcHAvc2hhcmVkL2NvbXBvbmVudHMvdGlja2V0cy90aWNrZXQvdGlja2V0LmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3RpY2tldHMvdGlja2V0L3RpY2tldC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3RpY2tldHMvdGlja2V0L3RpY2tldC5jb21wb25lbnQudHMuVGlja2V0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cInRpY2tldC1jb250YWluZXJcIj5cbiAgPHNwYW4gY2xhc3M9XCJxdWV1ZVwiPnt7dGlja2V0LnF1ZXVlfX08L3NwYW4+XG4gIDxhIHRhcmdldD1cIl9ibGFua1wiIGNsYXNzPVwiZGF0ZVwiIFtocmVmXT1cInRpY2tldC5saW5rXCIgW3BvcG92ZXJUaXRsZV09XCJ0aWNrZXQuc3ViamVjdFwiIFtwb3BvdmVyXT1cInRpY2tldC5kZXNjcmlwdGlvblwiIHBsYWNlbWVudD1cImJvdHRvbVwiXG4gICAgdHJpZ2dlcnM9XCJtb3VzZWVudGVyOm1vdXNlbGVhdmVcIj5cbiAgICB7e3RpY2tldC5kYXRlIHwgZGF0ZTonc2hvcnQnfX1cbiAgPC9hPlxuICA8aSBjbGFzcz1cImZhIGZhLWNoZWNrLWNpcmNsZSByZXNvbHZlXCIgKGNsaWNrKT1cIm9uUmVzb2x2ZUNsaWNrKClcIj48L2k+XG48L2Rpdj4iLCI8cmUtdGlja2V0PjwvcmUtdGlja2V0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzswRENBQTtNQUFBO01BQUEsNENBQThCO01BQUEsV0FDNUI7TUFBQTtNQUFvQiwwQ0FBdUI7TUFDM0M7VUFBQTtVQUFBO2FBQUE7d0VBQUE7VUFBQTtVQUFBLDRCQUNtQzthQUFBLE1BRS9CLDRDQUNKO1VBQUE7VUFBQTtZQUFBO1lBQUE7WUFBc0M7Y0FBQTtjQUFBO1lBQUE7WUFBdEM7VUFBQSxnQ0FBcUU7OztRQUpnQjtRQUFoQztRQUErRDtRQUNsSDtRQURGLFdBQXFGLFVBQWhDLFVBQStELFVBQ2xILFNBREY7OztRQURvQjtRQUFBO1FBQ1k7UUFBaEMsV0FBZ0MsU0FBaEM7UUFDbUM7WUFBQTtRQUFBOzs7O29CQ0hyQztNQUFBO2dDQUFBLFVBQUE7TUFBQTs7UUFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/shared/components/tickets/ticket/ticket.component.ngfactory.ts